import {
  GQLMaterialType,
  GQLPiece,
  GQLPieceConfiguration,
  GQLPieceReference,
  GQLPieceSize,
  GQLPlatingType,
  GQLStonesPlacementType
} from '@jewelutions/core-crm-server-api-client-domain';

export class GQLPieceHelper {
  static getAllAvailablePieceConfigurations(piece: GQLPiece): GQLPieceConfiguration[] {
    if (piece.models.length === 0) {
      return [];
    }
    return piece.models.map(m => m.availableConfigurations).reduce((c1, c2) => c1.concat(c2));
  }
}

export class GQLPieceReferenceHelper {
  static identical(c1: GQLPieceReference, c2: GQLPieceReference): boolean {
    return (
      c1.pieceId === c2.pieceId &&
      c1.pieceModelId === c2.pieceModelId &&
      GQLPieceConfigurationHelper.identical(c1.pieceConfiguration, c2.pieceConfiguration)
    );
  }
}

export class GQLPieceConfigurationHelper {
  static getAvailableStonePlacementTypes(
    pieceConfigurations: GQLPieceConfiguration[]
  ): Set<GQLStonesPlacementType> {
    const stonesPlacementTypes = new Set<GQLStonesPlacementType>();
    for (const pc of pieceConfigurations) {
      stonesPlacementTypes.add(pc.stonesPlacementType);
    }
    return stonesPlacementTypes;
  }

  static getAvailablePlatingTypes(pieceConfigurations: GQLPieceConfiguration[]): Set<GQLPlatingType> {
    const platingTypes = new Set<GQLPlatingType>();
    for (const pc of pieceConfigurations) {
      platingTypes.add(pc.platingType);
    }
    return platingTypes;
  }

  static getAvailableSizes(pieceConfigurations: GQLPieceConfiguration[]): Set<GQLPieceSize> {
    const pieceSizes = new Set<GQLPieceSize>();
    for (const pc of pieceConfigurations) {
      pieceSizes.add(pc.sizeType);
    }
    return pieceSizes;
  }

  static getAvailableMaterialTypes(pieceConfigurations: GQLPieceConfiguration[]): Set<GQLMaterialType> {
    const materialTypes = new Set<GQLMaterialType>();
    for (const pc of pieceConfigurations) {
      materialTypes.add(pc.materialType);
    }
    return materialTypes;
  }

  static identical(c1: GQLPieceConfiguration, c2: GQLPieceConfiguration): boolean {
    return (
      c1.sizeType === c2.sizeType &&
      c1.materialType === c2.materialType &&
      c1.platingType === c2.platingType &&
      c1.stonesPlacementType === c2.stonesPlacementType
    );
  }
}
